import { Box, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";

import "./eventLogImage.css";
import { ReactComponent as NoImageIcon } from "../../assets/icons/image-not-found-icon.svg";

interface IEventLogImageProps {
	src: string;
}

const EventLogImage: FC<IEventLogImageProps> = ({ src }) => {
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		if (src) {
			const img = new Image();
			img.src = src;
			img.onerror = () => setShowError(true);
			img.onload = () => setShowError(false);
		}
	}, [src]);

	if (showError) {
		return (
			<Box className="event-log-image-error-wrapper">
				<NoImageIcon width={18} fill="#d5d5d5" stroke="#d5d5d5" />
				<Typography variant="body2" color="#999999">
					Image not available
				</Typography>
			</Box>
		);
	}

	return (
		<Box className="event-log-image-wrapper">
			<Box className="event-log-image" sx={{ backgroundImage: `url(${src})` }} />
		</Box>
	);
};

export default EventLogImage;
